import { restApiDP } from "@plannel/services/utils/rest-api";

const get = () => {
  return restApiDP.get("/api/dp-process-mgmt")
};


const getBfStatus = (params) => {
  return restApiDP.get("/api/dp-process-mgmt/status", {params})
};

// 최근 BF 실행 상태 — { statusCd, startTs, endTs, errorMsg } (홈 파이프라인 "예측(BF)" 단계용, 최신 1행)
const getBfLatestStatus = (dpVersionId) => {
  return restApiDP.get("/api/dp-process-mgmt/bf-latest-status", { params: { dpVersionId } });
};

// 승인 위계·상태 — { enabled, myPostnCds, positions:[{ postnCd, name, postnPath, statusCd, updatedTs }] }
//   홈 '승인 대기' 카드용 경량 조회. /api/dp-process-mgmt 의 userStatus 와 같은 데이터지만,
//   그쪽은 measure 집계까지 함께 돌아서 랜딩에 못 쓴다.
const getApprovalStatus = () => {
  return restApiDP.get("/api/dp-process-mgmt/approval-status");
};

const getParameters = (params) => {
  return restApiDP.get("/api/dp-process-mgmt/baselineforecast", {params})
}

const dpProcessMgmtService = {
    get,
    getBfStatus,
    getBfLatestStatus,
    getApprovalStatus,
    getParameters
}

export default dpProcessMgmtService;